// @flow
import React from 'react'
import glamorous from 'glamorous'
import { Wrapper, Navigation } from 'components'
import Logo from 'assets/Logo.svg'
import { assitiveText, padding, margin, breakpoint } from 'style'
import Link from './atoms/Link'

const StyledHeader = glamorous.header({
  borderBottom: '1px solid #e6e6e6',
})

const Content = glamorous.div({
  ...padding.y(4),
  ...padding.x(2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  ...breakpoint.small({
    flexDirection: 'column',
  }),
})

const LogoLink = glamorous(Link)({
  display: 'flex',
  ...breakpoint.small({
    ...margin.y(3),
  }),
})

type Props = {
  title: string,
}

const Header = ({ title }: Props) => (
  <StyledHeader>
    <Wrapper>
      <Content>
        <LogoLink href="/">
          <Logo />
          <h1 style={{ ...assitiveText }}>{title}</h1>
        </LogoLink>
        <Navigation />
      </Content>
    </Wrapper>
  </StyledHeader>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js